<script>
import { euroCouponsCouponMethods, authComputed } from "@state/helpers";
import { required, maxLength } from "vuelidate/lib/validators";
import ConfirmModal from "./ConfirmModal.vue";
import ThirdpartyMultiselect from "@components/euro_coupons/thirdparty/Select";
import CustomDatePickerRange from "@components/CustomDatePickerRange";
import LoaderSquare from "@components/LoaderSquare";
import CustomMultiselect from "@/src/components/CustomMultiselect.vue";
import UploadData from "@components/euro_coupons/request_coupon/UploadData";

export default {
  name: "BaseDataTableRowSelect",
  components: {
    ConfirmModal,
    ThirdpartyMultiselect,
    CustomDatePickerRange,
    LoaderSquare,
    CustomMultiselect,
    UploadData,
  },
  props: {
    drfprovider: {
      type: Function,
      required: false,
      default: () => null,
    },
    provider: {
      type: Function,
      required: false,
      default: () => null,
    },
    tableheaders: {
      type: [Array, Object],
      required: true,
    },
    perpage: {
      type: Number,
      required: false,
      default: 10,
    },
    pageoptions: {
      type: Array,
      required: false,
      default() {
        let pages = [];
        let perpage = this.perpage;
        for (let index = 1; index <= 3; index++) {
          pages.push(index * perpage);
        }
        return pages;
      },
    },
    sortby: {
      type: String,
      required: false,
      default: "",
    },
    sortdesc: {
      type: NaN,
      required: false,
      default: null,
    },
    emptyText: {
      type: String,
      default: "Sin registros para mostrar",
    },
    emptyFilteredText: {
      type: String,
      default: "No se encontraron registros",
    },
    responsiveTable: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      isBusy: false,
      showForm: false,
      autogenerate: false,
      toUpdate: {},
      filter: null,
      totalRows: 1,
      currentPage: 1,
      lastFilter: "",
      selected: [],
      changeSelected: false,
      isChecked: null,
      isCheckedAll: null,
      submitting: false,
      loadingReport: false,
      showConfirmModal: false,
      is_thirdparty_user: false,
      form: {
        cxc: "",
        coupons: [],
      },

      stateOptions: [
        { label: "Valido", value: "valid" },
        { label: "Expirado", value: "expired" },
        { label: "Redimido", value: "redeemed" },
        { label: "Inactivo", value: "inactive" },
        { label: "Anulado", value: "nullified" },
        { label: "Redimido Parcialmente", value: "partial_redeemed" },
        { label: "Envío fallido", value: "sent_failed" },
      ],
      employeeOptions: [
        { label: "SI", value: "SI" },
        { label: "NO", value: "NO" },
      ],
      filters: {
        thirdparty: null,
        expiration_date__lte: null,
        expiration_date__gte: null,
        redemption_date__date__lte: null,
        redemption_date__date__gte: null,
        euro_employee: null,
        state: null,
      },
      filterset: null,
      cxcState: null,
      showDismissibleAlert: false,
    };
  },
  validations: {
    form: {
      cxc: { required },
      coupons: { required },
    },
  },
  watch: {
    selected(coupons) {
      this.form.coupons = coupons;
    },
    form: {
      deep: true,
      handler(form) {
        this.$v.form.cxc.$touch();
        this.cxcState = !this.$v.form.cxc.$invalid;
      },
    },

    filters: {
      deep: true,
      handler(filters) {
        let filters_list = [];
        for (let filter in filters) {
          if (filters[filter]) {
            let value = filters[filter];
            if (filter === "euro_employee") {
              value = filters[filter] === "SI";
            }
            filters_list.push(`${filter}=${value}`);
          }
        }
        if (filters_list.length) {
          this.filterset = filters_list.join("&");
        }
        this.getFilter();
      },
    },
  },

  computed: {
    ...authComputed,
  },

  mounted() {
    const _ = this;
    let user_info = _.currentSession.user.user_info;
    _.is_thirdparty_user = user_info.is_thirdparty_user;
    if (_.is_thirdparty_user) {
      _.filters.thirdparty = user_info.thirdparty_info.id;
    }
    _.autogenerate = user_info.thirdparty_info
      ? user_info.thirdparty_info.autogenerate_coupons
      : false;
  },

  methods: {
    ...euroCouponsCouponMethods,
    onFiltered(filteredItems) {
      if (this.filter !== this.lastFilter) {
        // Trying to resolve filter search issues when
        // changing pages with an active filter
        this.currentPage = 1;
        this.lastFilter = this.filter;
      }
    },
    baseProvider(ctx) {
      let context = this;
      ctx.filterset = context.filterset;

      let promise = this.drfprovider(ctx);
      if (promise) {
        return promise.then((data) => {
          this.totalRows = data.count;
          if (context.changeSelected) {
            context.toggleCheck(data.results);
            context.changeSelected = false;
          } else {
            data.results.forEach((coupon) => {
              let indexSelected = context.selected.findIndex(
                (item) => item.id === coupon.id
              );
              if (indexSelected !== -1) {
                // this.$set(coupon, 'selected', true)
                coupon["selected"] = true;
              } else {
                // this.$set(coupon, 'selected', false)
                coupon["selected"] = false;
              }
            });
          }
          context.isChecked = !data.results.some(
            (coupon) => coupon["selected"] === false
          );
          return data.results;
        });
      } else {
        return this.provider(ctx);
      }
    },
    onComplete() {
      this.selected = [];
      this.form.cxc = "";
      this.$refs.table.refresh();
    },
    refresh() {
      this.$refs.table.refresh();
    },
    toggleCheck(items) {
      let context = this;
      items.forEach((coupon) => {
        let indexSelected = context.selected.findIndex((item) => item.id === coupon.id);
        coupon.selected = context.isChecked;
        if (indexSelected === -1 && context.isChecked === true) {
          context.selected.push(coupon);
        } else if (indexSelected !== -1 && context.isChecked === false) {
          context.selected.splice(indexSelected, 1);
        }
      });
    },
    selectAllRows(check) {
      let context = this;
      context.isChecked = check;
      context.changeSelected = true;
      this.$refs.table.refresh();
    },
    clearSelected() {
      this.selected = [];
      this.$refs.table.refresh();
    },
    rowClicked(item) {
      let _ = this;
      if (_.is_thirdparty_user) return;
      if (item.selected) {
        item.selected = !item.selected;
        // this.$set(item, 'selected', false)
        let indexSelected = _.selected.findIndex(
          (selectedItem) => selectedItem.id === item.id
        );
        if (indexSelected !== -1) {
          _.selected.splice(indexSelected, 1);
        }
      } else {
        item.selected = !item.selected;
        // this.$set(item, 'selected', true)
        _.selected.push(item);
      }
    },
    tbodyRowClass(item, type) {
      /* Style the row as needed */
      if (_.is_thirdparty_user) return;
      if (type !== "row") {
        return;
      }
      if (item.selected) {
        return ["table-secondary", "cursor-pointer", "opacity-05"];
      } else {
        return ["cursor-pointer"];
      }
    },

    confirmSubmit() {
      let context = this;
      context.$v.form.$touch();
      if (context.$v.form.$invalid) {
        this.cxcState = !this.$v.form.cxc.$invalid;
        this.showDismissibleAlert = this.$v.form.coupons.$invalid;
        context.$generate_toast(context, "error", context.$t("fill_the_required_fields"));
        return;
      }
      context.showConfirmModal = true;
    },

    submit() {
      let context = this;
      context.submitting = true;
      const promise = context.setCxcEuroCouponsCoupon(context.form);
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            "success",
            `${context.$t("coupon")}s ${context.$t("updated")} ${context.$t("correctly")}`
          );
          setTimeout(() => {
            context.onComplete();
            context.submitting = false;
            context.showConfirmModal = false;
          }, 2000);
        })
        .catch((error) => {
          context.submitting = false;
          context.showConfirmModal = false;
          context.$axios_error_noty(error, context);
        });
    },
    getFilter() {
      this.lastFilter = "";
      this.onFiltered();
      setTimeout(() => this.refresh(), 200);
    },

    clear() {
      this.filters.expiration_date__gte = null;
      this.filters.expiration_date__lte = null;
      this.filters.redemption_date__date__gte = null;
      this.filters.redemption_date__date__lte = null;
      this.filters.euro_employee = null;
      this.filters.state = null;

      if (this.is_thirdparty_user === false) {
        this.filters["thirdparty"] = null;
      }
      this.filterset = null;
      setTimeout(() => this.refresh(), 200);
    },

    setFilter(filter, value) {
      this.filters[filter] = value;
    },

    getReport() {
      let _ = this;
      let context = this;
      _.loadingReport = true;
      let query = _.filterset ? `?${_.filterset}` : "";
      const promise = _.fetchDownloadCouponsReport({
        query,
        type: { responseType: "arraybuffer" },
      });
      return promise
        .then((response) => {
          const data = response.data;
          const url = URL.createObjectURL(
            new Blob([data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Reporte de Bonos.xlsx`);
          document.body.appendChild(link);
          link.click();
          _.loadingReport = false;
        })
        .catch((error) => {
          if (error.response.status === 400) {
            let msg =
              "El excel a generar debe ser menor a 5000 registros, por favor aplicar otro filtro";
            context.$generate_toast(context, "error", msg);
          } else {
            context.$axios_error_noty(error, context);
          }
          _.loadingReport = false;
        });
    },
  },
};
</script>
<template>
  <b-container fluid class="p-0">
    <b-card class="shadow-sm">
      <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
        <b>{{ $t("filters") }}</b>
      </b-row>
      <b-row>
        <b-col v-if="is_thirdparty_user === false" md="3">
          <ThirdpartyMultiselect
            v-if="is_thirdparty_user === false"
            :value="filters.thirdparty"
            @input="(value) => setFilter('thirdparty', value)"
          ></ThirdpartyMultiselect>
        </b-col>
        <b-col
          ><CustomDatePickerRange
            :label="'expiration_date'"
            :value_start="filters.expiration_date__gte"
            :value_end="filters.expiration_date__lte"
            @input_start="(value) => setFilter('expiration_date__gte', value)"
            @input_end="(value) => setFilter('expiration_date__lte', value)"
        /></b-col>
        <b-col class="p-0">
          <b-col
            ><CustomDatePickerRange
              :label="'redemption_date'"
              :value_start="filters.redemption_date__date__gte"
              :value_end="filters.redemption_date__date__lte"
              @input_start="(value) => setFilter('redemption_date__date__gte', value)"
              @input_end="(value) => setFilter('redemption_date__date__lte', value)"
          /></b-col>
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="d-flex">
          <CustomMultiselect
            :label="'state'"
            :options="stateOptions"
            :value="filters.state"
            @input="
              (value) => {
                setFilter('state', value);
              }
            "
          ></CustomMultiselect>
          <CustomMultiselect
            class="ml-2"
            :label="'euro_employee'"
            :options="employeeOptions"
            :value="filters.euro_employee"
            @input="
              (value) => {
                setFilter('euro_employee', value);
              }
            "
          ></CustomMultiselect>
        </b-col>
        <b-col class="pt-3 pr-1 mt-1">
          <!-- <b-button
            class="ml-1 rounded shadow-sm float-right"
            variant="outline-primary"
            @click="refresh"
            ><i class="fas fa-filter"></i>
          </b-button> -->
          <b-button
            class="rounded shadow-sm float-right"
            variant="outline-primary"
            @click="clear"
            ><i class="fas fa-eraser"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-alert
      variant="danger"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="showDismissibleAlert = false"
    >
      ¡Debe seleccionar al menos <b>un bono</b>!
    </b-alert>

    <b-card class="shadow-sm">
      <b-row>
        <b-col sm="12" md="3" v-if="!is_thirdparty_user">
          <b-form-group class="mb-0">
            <b-input-group>
              <div
                class="d-flex align-items-center border border-right-0 rounded-left"
                :class="{
                  'border-primary': cxcState === null,
                  'border-danger': cxcState === false,
                  'border-success': cxcState === true,
                }"
              >
                <span class="ml-2"><b>CXC</b></span>
              </div>
              <b-form-input
                class="border-left-0"
                :class="{ 'border-primary': cxcState === null }"
                v-model="form.cxc"
                :state="cxcState"
                aria-describedby="input-live-help input-live-feedback"
                placeholder="Ingrese la CXC para asignar"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="12" :md="is_thirdparty_user ? 6 : 3">
          <b-form-group label-for="filterInput" class="mb-0">
            <b-input-group>
              <div
                class="d-flex align-items-center border border-right-0 border-primary rounded-left"
              >
                <i class="fas fa-search ml-2"></i>
              </div>
              <b-form-input
                class="border-left-0 border-primary"
                id="filterInput"
                v-model="filter"
                debounce="600"
                type="search"
                :placeholder="$t('datatable.typetosearch')"
              ></b-form-input>
              <!-- <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">{{
                $t('datatable.clear')
              }}</b-button>
            </b-input-group-append> -->
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="5" md="6">
          <b-row class="d-flex flex-nowrap justify-content-end">
            <b-col class="d-flex justify-content-end border-right px-2" md="6">
              <b-button
                v-if="!is_thirdparty_user"
                variant="outline-primary rounded"
                :class="{ disabled: submitting }"
                @click="confirmSubmit"
                :disabled="submitting"
              >
                <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
                <span v-if="submitting"> {{ $t("saving") }} </span>
                <span v-else>
                  <i class="fas fa-save"></i>&nbsp;<b-badge v-if="selected.length">{{
                    selected.length
                  }}</b-badge>

                  <!-- {{ $t('save') }} -->
                </span>
              </b-button>
              <b-button
                variant="outline-primary rounded-lg  mx-1"
                :class="{ disabled: loadingReport }"
                :disabled="loadingReport"
                @click="getReport"
              >
                <b-spinner v-if="loadingReport" label="Spinning" small></b-spinner>
                <i v-else class="fas fa-download"></i>
              </b-button>

              <b-button
                v-if="!is_thirdparty_user"
                variant="outline-primary rounded-lg"
                @click="clearSelected"
              >
                <!-- {{ $t('clear_select') }} -->
                <i class="fas fa-broom"></i>
              </b-button>
              <b-button
                v-if="is_thirdparty_user"
                variant="outline-primary rounded-lg pt-1"
                size="sm"
                @click="
                  () => {
                    showForm = true;
                    toUpdate = {};
                  }
                "
              >
                <!-- <i class="fe-plus" style="font-size:18px"></i> -->
                <i class="far fa-trash-alt"></i>
              </b-button>
            </b-col>
            <!-- <b-col class="d-flex justify-content-end border-right px-2" md="3">

          </b-col> -->
            <b-col md="2" class="d-flex justify-content-end ml-3">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :page-class="['d-none']"
                :prev-class="['border', 'border-primary', 'rounded-left']"
                :next-class="['border', 'border-primary', 'rounded-right']"
                :hide-goto-end-buttons="true"
                :hide-ellipsis="true"
                :per-page="perpage"
                align="left"
                class="my-0"
              >
                <!-- <template #page>
			hola
		</template> -->
              </b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="p-2">
          <b-table
            ref="table"
            class="m-0"
            hover
            :items="baseProvider"
            :fields="tableheaders"
            :per-page="perpage"
            :current-page="currentPage"
            :busy="isBusy"
            :filter="filter"
            :sort-by.sync="sortby"
            :sort-desc.sync="sortdesc"
            :responsive="responsiveTable"
            show-empty
            :empty-text="emptyText"
            :empty-filtered-text="emptyFilteredText"
            @filtered="onFiltered"
            :select-mode="'multi'"
            selectable
            no-select-on-click
            :selected-variant="''"
            @row-clicked="rowClicked"
            :tbody-tr-class="tbodyRowClass"
            :thead-class="['text-primary']"
          >
            <template #head(selected)>
              <b-form-checkbox v-model="isChecked" @change="selectAllRows">
                {{ $t("select") }}
              </b-form-checkbox>
            </template>
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
              ><slot :name="slot" v-bind="scope"
            /></template>
            <template v-slot:table-busy>
              <div
                class="d-flex flex-column align-items-center text-center text-corp my-4"
              >
                <LoaderSquare />
                <strong> {{ $t("datatable.loading") }}...</strong>
              </div>
            </template>
            <!-- Example scoped slot for select state illustrative purposes -->
            <template
              v-slot:cell(selected)="{ item, field: { key } }"
              v-if="!is_thirdparty_user"
            >
              <i
                v-if="item.selected"
                class="fas fa-check-square text-primary"
                style="font-size: 20px"
              ></i>
              <i v-else class="far fa-square text-secondary" style="font-size: 20px"></i>
            </template>

            <!-- Example scoped slot for select state illustrative purposes -->
            <template v-slot:cell(cxc)="data">
              <b v-if="data.item.selected" class="text-primary">{{ form.cxc }}</b>
              <span v-else>{{ data.value }}</span>
            </template>
          </b-table>
          <b-row class="mw-100 mt-2">
            <b-col class="d-flex justify-content-end p-0">
              <div class="d-flex pt-2 pr-3">
                <b class="text-primary">
                  {{ !totalRows ? 0 : (currentPage - 1) * perpage + 1 }}
                  -
                  {{
                    !totalRows
                      ? 0
                      : currentPage * perpage >= totalRows
                      ? totalRows
                      : currentPage * perpage
                  }}
                  {{ $t("datatable.of") }} {{ totalRows }}
                </b>
              </div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perpage"
                :hide-ellipsis="true"
                :first-class="['border', 'border-primary', 'rounded']"
                :prev-class="['border', 'border-primary', 'rounded']"
                :page-class="['border', 'border-primary', 'rounded']"
                :next-class="['border', 'border-primary', 'rounded']"
                :last-class="['border', 'border-primary', 'rounded']"
              ></b-pagination>
              <div>
                <b-dropdown id="dropdown-header" variant="outline-primary rounded">
                  <template #button-content>
                    <i class="fas fa-cog"></i>
                  </template>
                  <b-dropdown-header id="dropdown-header-label">
                    {{ $t("datatable.recordsperpage") }}
                  </b-dropdown-header>
                  <b-dropdown-item-button
                    v-for="option in pageoptions"
                    :key="option"
                    @click="perpage = option"
                  >
                    {{ option }}
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row> </b-row>
    </b-card>
    <ConfirmModal
      v-if="showConfirmModal"
      :close-modal="
        () => {
          showConfirmModal = false;
        }
      "
      :on-submit="submit"
      :submitting="submitting"
      :warningMessage="'¿Con seguridad va asignar la CXC sobre los bonos seleccionados?'"
    />
    <UploadData
      v-if="showForm && !autogenerate"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.table.refresh();
        }
      "
      :oncancel="
        () => {
          showForm = false;
          toUpdate = {};
        }
      "
      type_action="delete"
    >
    </UploadData>
  </b-container>
</template>
<style>
.cursor-pointer {
  cursor: pointer;
}

.page-item {
  margin: 0px 2px;
}
.page-link {
  border: none;
  color: dimgray;
  margin: 1px;
}

.page-item.active .page-link {
  boder: none;
  color: #0570a7;
  background: none;
  /* background: rgba(0, 60, 255, 0.138); */
  font-weight: 900;
}
</style>
